import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "../components/PageHero";
import Gallery from "../components/Gallery";

const GALLERY = [
  "https://kikicentre.com/wp-content/uploads/2022/03/st1.jpg",
  "https://kikicentre.com/wp-content/uploads/2022/03/st2.jpg",
  "https://kikicentre.com/wp-content/uploads/2022/03/st3.jpg",
  "https://images.pexels.com/photos/7616700/pexels-photo-7616700.jpeg?auto=compress&cs=tinysrgb&w=800",
  "https://images.pexels.com/photos/20200756/pexels-photo-20200756.jpeg?auto=compress&cs=tinysrgb&w=800",
  "https://images.unsplash.com/photo-1770967004881-5e8795cb5fde?w=800&q=80",
];

const cards = [
  {
    title: "Activities",
    img: "https://kikicentre.com/wp-content/uploads/2022/03/st1.jpg",
    desc: "We make sure that the students' overall growth is taken care of. Lots of activities are woven into their daily life to enhance their mental and physical fitness.",
    to: "/activities",
  },
  {
    title: "Residential Life",
    img: "https://kikicentre.com/wp-content/uploads/2022/03/st2.jpg",
    desc: "Accommodation is available in the nearby housing area of IMT Manesar, so students have a good time both inside and outside the training institute.",
    to: "/residential-life",
  },
  {
    title: "Life in Millennium City",
    img: "https://kikicentre.com/wp-content/uploads/2022/03/st3.jpg",
    desc: "Located in Gurgaon, India's Millennium City, students get plenty of recreational and constructive activities on their days off.",
    to: "/life-in-the-millennium-city",
  },
];

export default function StudentLifePage() {
  return (
    <div data-testid="student-life-page">
      <PageHero
        path="student-life.hero"
        kicker="Student Life"
        title="Student life is highly enjoyable at Kiki"
        subtitle="While classes are highly demanding, a fully loaded social, cultural and sporting calendar ensures all-round development. Recreational facilities let students simply wind down after a busy day."
      />
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-3 gap-8">
          {cards.map((c) => (
            <Link
              key={c.title}
              to={c.to}
              data-testid={`student-life-card-${c.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="group bg-white rounded-2xl overflow-hidden shadow-sm border border-slate-100 hover:shadow-xl transition tilt-card"
            >
              <div className="h-52 overflow-hidden">
                <img src={c.img} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#0B2A6B] mb-2">{c.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{c.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-yellow-600 group-hover:gap-2.5 transition-all">
                  Read More <ArrowRight className="h-4 w-4" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="pb-16" data-testid="student-life-gallery">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <p className="kicker mb-3">Gallery</p>
            <h2 className="text-3xl font-bold text-[#0B2A6B]">Life on campus</h2>
          </div>
          <Gallery images={GALLERY} testid="student-life-gallery-grid" />
        </div>
      </section>
    </div>
  );
}
